import React, { useState } from 'react';
import './CreatePasswordInput.css';
import WrongIcon from './icons/WrongIcon';
import CorrectIcon from './icons/CorrectIcon';
import PasswordInput from './PasswordInput';
import intl from 'react-intl-universal';

const validationMessages = {
  minValueValidation: 'Password must be at least 8 Characters',
  numberValidation: 'Password must have at least one Number',
  capitalLetterValidation: 'Password must have at least one Capital Letter',
  specialCharacterValidation: 'Password must have at least one Special Character',
};

const CreatePasswordInput = ({ defaultValue, onPasswordChange, ...props }) => {
  const [password, setPassword] = useState(defaultValue);
  const [errors, setErrors] = useState({
    minValueValidation: false,
    numberValidation: false,
    capitalLetterValidation: false,
    specialCharacterValidation: false,
  });

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    const isValid = validatePassword(newPassword);
    if (onPasswordChange) {
      onPasswordChange(newPassword, isValid);
    }
  };

  const validatePassword = (password) => {
    const newErrors = {
      minValueValidation: password.length >= 8,
      numberValidation: /\d/.test(password),
      capitalLetterValidation: /[A-Z]/.test(password),
      specialCharacterValidation: /[^A-Za-z0-9]/.test(password),
    };
    setErrors(newErrors);
    return Object.values(newErrors).every(Boolean);
  };

  const helperText = (
    <div className="password-input-container">
      {Object.entries(errors).map(([key, value]) => (
        <div key={key} className="validation-container">
          {value ? (
            <CorrectIcon wrapperClass="validation-icon icon-green" />
          ) : (
            <WrongIcon wrapperClass="validation-icon icon-red" />
          )}
          <div className={`validation-text ${value ? 'validation-text-green' : 'validation-text-red'}`}>
            {intl.get(key).defaultMessage(validationMessages[key])}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <PasswordInput
      {...props}
      value={password}
      onChange={handlePasswordChange}
      FormHelperTextProps={{ component: 'div' }} 
      helperText={helperText}
    />
  );
};

export default CreatePasswordInput;
